import * as React from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={19}
        height={19}
        fill="none"
        {...props}
    >
        <path
            fill="#00000099"
            d="m18.664 16.507.129-.13a.593.593 0 0 0 .206-.463.63.63 0 0 0-.206-.465 156.71 156.71 0 0 1-.129-.129c.438.232.438.98 0 1.187ZM6.104 13.23a.928.928 0 1 0 0-1.857.928.928 0 0 0 0 1.857ZM10.566 8.923a.619.619 0 1 0 0-1.237.619.619 0 0 0 0 1.237ZM6.698 9.337a1.032 1.032 0 1 0 0-2.064 1.032 1.032 0 0 0 0 2.064ZM14.898 9.412a1.006 1.006 0 1 0 0-2.012 1.006 1.006 0 0 0 0 2.012ZM10.565 13.772a1.65 1.65 0 1 0 0-3.301 1.65 1.65 0 0 0 0 3.3ZM14.899 12.946a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM6.413 5.365a.928.928 0 1 0 0-1.857.928.928 0 0 0 0 1.857ZM10.875 5.544a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58ZM15.207 5.08a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM3.188.077a.716.716 0 0 0-.465 0 .416.416 0 0 0-.18.104A.604.604 0 0 1 2.981 0c.078.026.155.026.207.077Z"
        />
        <path
            fill="#00000099"
            d="M3.395.18c-.051-.05-.129-.077-.18-.102h-.026a.716.716 0 0 0-.464 0c.077-.052.154-.052.232-.052a.495.495 0 0 1 .438.155Z"
        />
        <path
            fill="#00000099"
            d="M18.974 15.938a.63.63 0 0 1-.207.464l-.128.13c-.439.438-.877.876-1.342 1.289-.593.567-1.495-.335-.902-.903.103-.103.232-.206.335-.335H3.113c-.052 0-.129 0-.18-.026-.31-.026-.62-.232-.62-.619V2.27c-.103.104-.206.233-.335.336-.567.593-1.496-.31-.902-.903.464-.464.928-.954 1.366-1.418l.052-.052.026-.026C2.57.155 2.649.13 2.7.103a.716.716 0 0 1 .464 0h.026c.052.026.13.052.18.103 0 0 .027 0 .027.026l.051.052c.464.464.929.928 1.367 1.418.593.593-.335 1.496-.903.903-.103-.103-.206-.232-.335-.336v13.05h13.127l-.335-.335c-.593-.567.31-1.496.903-.903.438.439.877.877 1.34 1.29l.13.129c.18.103.258.283.232.438Z"
        />
    </svg>
)
export default SvgComponent
